// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__+LHvt","contactAddress":"contact_contactAddress__2ln6h"};